import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import LeadListEntry from 'components/project/lead_list_entry';

export default class LeadsList extends React.Component {
  static propTypes = {
    leads: PropTypes.array.isRequired
  };

  render() {
    return (
      <table className="table leads-list-component">
        <thead>
          {this.renderHeader()}
        </thead>
        <tbody>
          {this.renderLeads()}
        </tbody>
      </table>
    );
  }

  renderHeader() {
    return (
      <tr>
        <th>Project</th>
        <th>Status</th>
        <th>Added By</th>
        <th>{/* Actions */}</th>
      </tr>
    );
  }

  renderLeads() {
    const { leads } = this.props;

    return map(leads, lead => (
      <LeadListEntry key={lead.id} lead={lead} name={`lead-${lead.id}`} />
    ));
  }
}
